import React from 'react';

import { TermActionDesktop } from '../shared/TermAction/desktop';
import { TermActionViewProps } from '../shared/TermAction/types';

export const TermAcceptanceDesktop: React.FC<TermActionViewProps> = (props) => {
  return <TermActionDesktop {...props} />;
};
